import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const InvoicePdfLinksResponseSchema = z
  .object({
    data: z.object({
      invoice_path: z.string(),
    }),
  })
  .transform((data) => transformKeysToCamelCase(data));

export type TInvoicePdfLinksDataResponse = z.infer<typeof InvoicePdfLinksResponseSchema>;
export type TInvoicePdfLinksData = TInvoicePdfLinksDataResponse['data'];
